import {
  CubeReducerState,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'

export const getDefaultDueDateDaysAvailable = (
  _prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => ({
  available: {
    visible: true,
    enabled: true
  },
  reasons: []
})
